import React from "react";
import { Upload, Input, Select, InputNumber, Form, Row, Col } from "antd";
import UploadQiniu from "../UploadQiniu";
import { PlusOutlined } from "@ant-design/icons";
import { setUploadItem } from "../../util";
import * as qiniu from "qiniu-js";
import styles from "./index.module.less";

const formItemLayout = {
  // labelCol: {
  //   xs: {
  //     span: 24,
  //   },
  //   sm: {
  //     span: 8,
  //   },
  // },
  // wrapperCol: {
  //   xs: {
  //     span: 24,
  //   },
  //   sm: {
  //     span: 16,
  //   },
  // },
};

const LotteryItem = React.forwardRef(({ lotteryItemRef, ...props }) => {
  const [form] = Form.useForm();
  const onFinish = (values) => {};
  const { item } = props;
  const onGetFormData = () => {
    return;
    const values = form.getFieldsValue();
    console.log("values", values);
  };
  // 暴露组件的方法
  React.useImperativeHandle(lotteryItemRef, () => ({
    getFormData,
  }));
  const getFormData = async () => {
    const formItem = await form.validateFields();
    const newFormItem = { ...formItem };
    newFormItem.lotteryImage = newFormItem.lotteryImage.fileList;
    newFormItem.lotteryImage =
      newFormItem.lotteryImage &&
      newFormItem.lotteryImage.map((ele) => {
        if (ele && ele.url) {
          return ele.url;
        }
        if (ele && ele.response && ele.response.file && ele.response.file.url) {
          return ele.response.file.url;
        }
        return null;
      });
    if (newFormItem.lotteryImage.some((ele) => !ele)) {
      message.error("有图片上传中或错误");
      return Promise.reject();
    }
    newFormItem.lotteryImage =
      newFormItem.lotteryImage && newFormItem.lotteryImage.join(",");
    return newFormItem;
  };
  return (
    <div className={styles.lotteryItem} onClick={onGetFormData}>
      <div
        className={styles.lotteryItemAdd}
        onClick={props.onCreateLotteryItem}
      >
        <PlusOutlined />
      </div>
      <Form
        className={styles.formWrap}
        {...formItemLayout}
        form={form}
        layout="vertical"
        name="register"
        onFinish={onFinish}
        initialValues={{
          lotteryType: item.lotteryType,
          lotteryTitle: item.lotteryTitle,
          lotteryPrice: item.lotteryPrice,
          lotteryNumber: item.lotteryNumber,
          // lotteryPreJoinNumber: 50,
          lotteryWinningJoinNumber: item.lotteryWinningJoinNumber,
          lotteryImage: { fileList: setUploadItem(item.lotteryImage) },
        }}
        scrollToFirstError
      >
        <Row gutter={24}>
          <Col span={12}>
            <Form.Item
              className={styles.lotteryFormItem}
              name="lotteryType"
              label="奖品类型"
              rules={[
                {
                  required: true,
                  message: "请选择",
                },
              ]}
            >
              <Select
                placeholder="请选择奖品类型"
                className={styles.lotteryItemInput}
                defaultValue={item.lotteryType}
              >
                <Select.Option value={1}>实物</Select.Option>
                <Select.Option value={2}>金币</Select.Option>
              </Select>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className={styles.lotteryFormItem}
              name="lotteryTitle"
              label="奖品名称"
              rules={[
                {
                  required: true,
                  message: "请输入",
                },
              ]}
            >
              <Input
                placeholder="请输入奖品名称"
                className={styles.lotteryItemInput}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className={styles.lotteryFormItem}
              name="lotteryPrice"
              label="奖品金额"
              rules={[
                {
                  required: true,
                  message: "请输入",
                },
              ]}
            >
              <InputNumber
                placeholder="请输入奖品金额"
                className={styles.lotteryItemInput}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className={styles.lotteryFormItem}
              name="lotteryNumber"
              label="奖品数量"
              rules={[
                {
                  required: true,
                  message: "请输入",
                },
              ]}
            >
              <InputNumber
                placeholder="请输入奖品数量"
                className={styles.lotteryItemInput}
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item
              className={styles.lotteryFormItem}
              name="lotteryWinningJoinNumber"
              label="预定中奖人数"
              rules={[
                {
                  required: false,
                  message: "请输入",
                },
              ]}
            >
              <InputNumber
                placeholder="请输入预定中奖人数"
                className={styles.lotteryItemInput}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item
              className={styles.lotteryFormItem}
              name="lotteryImage"
              label="图片"
              rules={[
                {
                  required: true,
                  message: "请选择",
                },
              ]}
              // valuePropName="fileList"
            >
              <UploadQiniu />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </div>
  );
});

const LotteryList = ({ value = [], lotteryListRef, onChange }) => {
  const lotteryItemRef = React.useRef({});
  let newValue = [...value];
  // 暴露组件的方法
  React.useImperativeHandle(lotteryListRef, () => ({
    getFormData,
  }));
  const getFormData = () => {
    return Promise.all(
      newValue.map((ele, index) => {
        return lotteryItemRef.current[index].getFormData();
      })
    );
  };
  const onCreateLotteryItem = () => {
    onChange([...newValue, {}]);
  };
  console.log("newValue", newValue);
  if (newValue && newValue.length === 0) {
    onChange([...newValue, {}]);
  }

  return (
    <div className={styles.lotteryList}>
      {newValue.map((ele, index) => (
        <LotteryItem
          item={ele}
          key={ele.id}
          onCreateLotteryItem={onCreateLotteryItem}
          lotteryItemRef={(ref) => {
            lotteryItemRef.current[index] = ref;
          }}
        />
      ))}
    </div>
  );
};

export default React.forwardRef(LotteryList);
